module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.880cffe4.woff2";